export const setToLocalStorageFilters = (data, key: string) => {
  localStorage.setItem(`filter-${key}-filters`, JSON.stringify(data))
}

export const getToLocalStorageFilters = (key: string): string => {
  return <string>localStorage.getItem(`filter-${key}-filters`)
}
